import type {
  VendorSearchRequest,
  SearchVendorContactsRequest,
  VendorGetRequest,
  VendorContactDetailsRequest,
} from '@trukt/tms-api';
import { createKey } from './createKey';

const contactKeyHandler = createKey('vendor-contact');
const vendorKeyHandler = createKey('vendor');

const VendorContactServiceKeys = {
  key: contactKeyHandler.key,
  search: contactKeyHandler.createMethod<SearchVendorContactsRequest>(),
  getById: contactKeyHandler.createMethod<VendorContactDetailsRequest>(),
};

export const VendorServiceKeys = {
  key: vendorKeyHandler.key,
  contact: VendorContactServiceKeys,
  search: vendorKeyHandler.createMethod<VendorSearchRequest>(),
  getById: vendorKeyHandler.createMethod<VendorGetRequest>(),
};
